import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUser, setLang} from '../Actions/UserActions';

import Loading from '../Components/Loading';



class LoadingComponent extends Component {
  componentWillMount() {
      const {userLoading,} = this.props;


      if (userLoading === undefined) {
        // console.log("willunmount")
          this.props.getUser();
          this.props.setLang( navigator.language || navigator.userLanguage,)

      }



  }
  
  componentWillReceiveProps(nextProps) {


      if(nextProps.userLoading === false && nextProps.postsLoading === undefined) {

          if (nextProps.user !== null) {
             // console.log("Step2")

              this.props.setLang("en")


              // console.log("uid_pl", this.props.user.uid)
          }
      }

    if(nextProps.postsLoading === -1 && nextProps.user !== null) {



        this.props.setLang("en")
    }
  }

  render() {
    const { userLoading, postsLoading, children, adminLoading } = this.props;
    if((!userLoading && !postsLoading && !adminLoading) || (this.props.user === null)) {
      return (
        <div>
          {children}
        </div>
      )
    }
    else {
      return (
        <Loading />
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    userLoading: state.loading.user,
    postsLoading: state.loading.posts,
      unbookedLoading: state.loading.unbooked,
     historyLoading: state.loading.history,
      adminloading: state.loading.admin,
    user: state.user,
      res: state.res,

      his: state.his
  };
}

export default withRouter(connect(mapStateToProps, { getUser, setLang })(LoadingComponent))



// WEBPACK FOOTER //
// ./src/Containers/LoadingComponent.js